import { css } from '@emotion/react'
import { Divider, colors } from 'plume-ui'
import { SourcingRoute } from '../../reducers/sourcingAnnotationCandidates'
import { User } from 'types'
import { useUser } from '@/contexts/AuthContext'
import { OptionDropdown } from '@/components/view/OptionDropdown'
import { OptionDropdownItem } from '@/components/view/OptionDropdownItem'

type Props = {
  sourcingRoutes: SourcingRoute[]
  selectedSourcingRouteId: number | null | undefined
  maxHeight?: number
  position?: { top?: number; right?: number; bottom?: number; left?: number }
  onSelectSourcingRoute: (
    sourcingRouteId: number,
    sourcingRouteName: string,
    user: User
  ) => void
  onDeselectSourcingRoute: (user: User) => void
  onRequestEditSourcingRouteModal: () => void
}

export const SourcingRouteDropdown: React.FC<Props> = ({
  sourcingRoutes,
  selectedSourcingRouteId,
  maxHeight = 320,
  position: { top, right, bottom, left } = {},
  onSelectSourcingRoute,
  onDeselectSourcingRoute,
  onRequestEditSourcingRouteModal,
}) => {
  // NOTE: ここで useUser() したくない。消したい。
  const user = useUser()
  return (
    <OptionDropdown
      dataTestId="sourcing-route-dropdown"
      _css={css`
        display: flex;
        flex-direction: column;
        min-width: 300px;
        max-height: ${maxHeight}px;
        overflow-y: auto;
        ${top != null ? `top: ${top}px;` : ''}
        ${right != null ? `right: ${right}px;` : ''}
        ${bottom != null ? `bottom: ${bottom}px;` : ''}
        ${left != null ? `left: ${left}px;` : ''}
      `}
      open={true}
      hideTopArrow
    >
      <div
        css={css`
          flex: 1;
          overflow-y: auto;
        `}
      >
        <OptionDropdownItem
          label="（空白）"
          dataTestId="sourcing-route-dropdown-item-empty"
          condition={selectedSourcingRouteId == null}
          idx={0}
          handleSet={() => {
            onDeselectSourcingRoute(user)
          }}
        />
        {sourcingRoutes.map((sr, idx) => {
          const isSelected = selectedSourcingRouteId === sr.id
          return (
            <OptionDropdownItem
              key={sr.id}
              dataTestId={'sourcing-route-dropdown-item'}
              condition={isSelected}
              idx={idx}
              handleSet={(e) => {
                e.preventDefault()
                onSelectSourcingRoute(sr.id, sr.name, user)
              }}
              label={sr.name}
              _css={css`
                max-width: 320px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              `}
            />
          )
        })}
      </div>
      <div
        css={css`
          flex-shrink: 1;
        `}
      >
        <Divider
          css={css`
            margin: 4px 0;
          `}
        />
        <OptionDropdownItem
          dataTestId={'sourcing-route-edit-menu'}
          condition={true}
          idx={0}
          handleSet={(e) => {
            e.preventDefault()
            onRequestEditSourcingRouteModal()
          }}
          label={'ソーシングルート項目を編集'}
          icon="icon-pen-fill"
          iconCss={css`
            color: ${colors.textLight};
          `}
        />
      </div>
    </OptionDropdown>
  )
}
